import { About } from '../components/landing/about';
import { Benchmarks } from '../components/landing/benchmarks';
import { Comparison } from '../components/landing/comparison';
import { Deliverables } from '../components/landing/deliverables';
import { Faq } from '../components/landing/faq';
import { FinalCta } from '../components/landing/final-cta';
import { Hero } from '../components/landing/hero';
import { HowItWorks } from '../components/landing/how-it-works';
import { Pricing } from '../components/landing/pricing';
import { WhatWeCheck } from '../components/landing/what-we-check';
import { WhyItMatters } from '../components/landing/why-it-matters';

export function LandingPage() {
  return (
    <>
      <Hero />
      <WhyItMatters />
      <HowItWorks />
      <Comparison />
      <WhatWeCheck />
      <Benchmarks />
      <Deliverables />
      <Pricing />
      <About />
      <Faq />
      <FinalCta />
    </>
  );
}
